import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Company } from '../../../../shared/interfaces/company';
import { ClickOutsideDirective } from '../../../../shared/directives/click-outside/click-outside.directive';
import { Clipboard } from '@angular/cdk/clipboard';
import { LeadsService } from '../../services/leads.service';
import { DestroyBase } from '../../../../shared/base-classes/destroy-component-base';
import { takeUntil } from 'rxjs';
import { CompanyDetails } from '../../../../shared/models/company-details';
import { SvgIconComponent } from '../../../../shared/components/svg-icon/svg-icon.component';

@Component({
  selector: 'app-inquiry-form-links',
  standalone: true,
  imports: [ClickOutsideDirective, SvgIconComponent],
  templateUrl: './inquiry-form-links.component.html',
  styleUrl: './inquiry-form-links.component.scss',
})
export class InquiryFormLinksComponent
  extends DestroyBase
  implements OnChanges
{
  @Input({ required: true }) Leads!: Company[];

  @Output() popupClosed = new EventEmitter();

  clipboard = inject(Clipboard);
  leadsService = inject(LeadsService);

  idUrlMap: Record<string, string> = {};

  ngOnChanges(changes: SimpleChanges) {
    if (changes['Leads'] && changes['Leads'].currentValue) {
      const leadIds = this.Leads.map((lead) => lead.leadId).join(',');
      this.leadsService
        .getLeadsDetailByIds(leadIds)
        .pipe(takeUntil(this.destroy$))
        .subscribe((details: CompanyDetails[]) => {
          details.forEach((lead) => {
            const orgName = lead.detail.properties.find(
              (p) => p.property_name === 'Company Name',
            );
            const streetAddressLine1 = lead.detail.properties.find(
              (p) => p.property_name === 'Address',
            );
            const state = lead.detail.properties.find(
              (p) => p.property_name === 'State',
            );
            const addressRegion = lead.detail.properties.find(
              (p) => p.property_name === 'City',
            );
            const postalCode = lead.detail.properties.find(
              (p) => p.property_name === 'Postal Code',
            );
            let url = `https://nimed.tfaforms.net/6?tfa_18=${orgName?.value}&tfa_21=${streetAddressLine1?.value}&tfa_23=${state?.value}&tfa_23=${addressRegion?.value}&tfa_82=${postalCode?.value}`;
            const isSmallBusiness = lead.detail.properties.find(
              (p) => p.property_name === 'Is Small Business',
            );
            if (isSmallBusiness?.value) {
              url += '&tfa_87=true';
            }
            const legalForm = lead.detail.properties.find(
              (p) => p.property_name === 'Legal Form',
            );
            if (legalForm?.value) {
              switch (legalForm.value) {
                case 'Limited Partnership':
                case 'Partnership':
                  url += '&tfa_96=true';
                  break;
                case 'Limited Liability Company':
                case 'LLC':
                  url += '&tfa_93=true';
                  break;
                case 'Corporation':
                  url += '&tfa_94=true';
                  break;
              }
            }
            const startDate = lead.detail.properties.find(
              (p) => p.property_name === 'Founded Date',
            );
            if (startDate?.value) {
              const dateParts = startDate.value.split('-');
              if (dateParts.length > 1) {
                const date = `${dateParts[1]}/${dateParts[2]}/${dateParts[0]}`;
                url += `&tfa_233=${date}`;
              }
            }
            this.idUrlMap[lead.unique_id] = url;
          });
        });
    }
  }

  closePopup(): void {
    this.popupClosed.emit();
  }

  copyFormUrl(lead: Company): void {
    const copy = document.getElementById(lead.unique_id);
    if (copy) {
      copy.innerText = 'Copied!';
      setTimeout(() => {
        copy.innerText = 'Copy';
      }, 3000);
    }
    this.clipboard.copy(this.idUrlMap[lead.unique_id]);
  }
}
